import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { UseQueryResult } from '@tanstack/react-query'
import { isUndefined } from 'lodash'
import { scanEmcMyPv } from '../api'
import { MyPvNetworkScanModel } from '../types'
import { usePortalQuery } from 'src/Libs/api'

/** Hook to fetch the MyPV network scan result for a specific EMC device */
export const useFetchScanEmcMyPv = (installationId: number | null, emcId: string | undefined): UseQueryResult<MyPvNetworkScanModel, Error> => {
  const authFetch = useAuthFetchWithResponse()

  return usePortalQuery({
    queryKey: ['installation', installationId, 'emc', emcId, 'scan-my-pv'],
    queryFn: async () => {
      if (installationId === null || emcId === undefined) {
        throw new Error('Query called without required params')
      }
      const { value, error, hasErrors } = await scanEmcMyPv(installationId, emcId, authFetch)
      if (hasErrors) {
        throw error
      }
      return value
    },
    enabled: !isUndefined(emcId) && !!installationId,
    staleTime: 0,
  })
}
